import React, {FunctionComponent} from 'react';
import {Box, Typography} from '@mui/material';
import LazyImage from '../../../app-specific/lazy-image';
// @ts-ignore
import noBizLearnVideoImage from '../../../../../assets/images/no-bizlearn-video-image.png';
import HighlightText from '../../../app-specific/highlight-text';

export interface TutorialVideo {
    url: string;
    imageUrl?: string;
    title: string;
}

export const VIDEO_ROW_HEIGHT = 68;
const THUMB_WIDTH = 96;
const THUMB_HEIGHT = 54;

interface VideoRowProps {
    tutorial: TutorialVideo;
    searchQuery: string;
}

/** Compact horizontal Biz Learn video link row with optional title highlighting. */
const VideoRow: FunctionComponent<VideoRowProps> = ({tutorial, searchQuery}) => (
    <Box
        component="a"
        href={tutorial.url}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            height: VIDEO_ROW_HEIGHT,
            px: 1,
            textDecoration: 'none',
            color: 'inherit',
            borderRadius: 1,
            '&:hover': {
                bgcolor: 'action.hover',
            },
        }}
    >
        {/*@ts-ignore*/}
        <LazyImage
            alt={tutorial.title}
            src={tutorial.imageUrl}
            height={THUMB_HEIGHT}
            style={{
                height: THUMB_HEIGHT,
                width: THUMB_WIDTH,
                flexShrink: 0,
                borderRadius: 6,
                objectFit: 'cover',
                objectPosition: 'center',
            }}
            noImage={(
                <img
                    src={noBizLearnVideoImage}
                    style={{
                        height: THUMB_HEIGHT,
                        width: THUMB_WIDTH,
                        borderRadius: 6,
                        objectFit: 'cover',
                        objectPosition: 'center',
                    }}
                    alt={tutorial.title}
                />
            )}
        />
        <Typography
            variant="body2"
            fontWeight={600}
            sx={{
                flex: 1,
                minWidth: 0,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                lineHeight: 1.35,
            }}
        >
            <HighlightText text={tutorial.title} query={searchQuery}/>
        </Typography>
    </Box>
);

export default VideoRow;
